import { render, staticRenderFns } from "./I18nField.vue?vue&type=template&id=0be67330&scoped=true"
import script from "./I18nField.vue?vue&type=script&lang=js"
export * from "./I18nField.vue?vue&type=script&lang=js"
import style0 from "./I18nField.vue?vue&type=style&index=0&id=0be67330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be67330",
  null
  
)

export default component.exports